type Aviso = () => void;

/**
 * Highcharts so reflui quando a janela muda de tamanho: trocar a largura do
 * container (abrir a sidebar, trocar de aba) deixava o grafico cortado.
 */
export const observarRedimensionamento = (elemento: HTMLElement, aviso: Aviso) => {
  let quadro = 0;
  let descartado = false;

  const agendar = () => {
    if (quadro || descartado) {
      return;
    }
    quadro = window.requestAnimationFrame(() => {
      quadro = 0;
      aviso();
    });
  };

  const cancelarQuadro = () => {
    descartado = true;
    if (quadro) {
      window.cancelAnimationFrame(quadro);
      quadro = 0;
    }
  };

  const Observador = (window as any).ResizeObserver;
  if (typeof Observador === "function") {
    const observador = new Observador(agendar);
    observador.observe(elemento);
    return () => {
      cancelarQuadro();
      observador.disconnect();
    };
  }

  window.addEventListener("resize", agendar);
  return () => {
    cancelarQuadro();
    window.removeEventListener("resize", agendar);
  };
};
